const FLEX_DIRECTION_SELECTORS = ['ws-block[src*="/custom/"] ws-columns'];

const hasFlexRowReverseParent = (element) => {
  const parent = element?.parentElement;
  if (!parent || !FLEX_DIRECTION_SELECTORS.some((selector) => parent.matches(selector)))
    return false;

  const frameWindow = element.ownerDocument?.defaultView;
  if (!frameWindow) return false;

  const { display, flexDirection } = frameWindow.getComputedStyle(parent);

  return display === 'flex' && flexDirection === 'row-reverse';
};

export default hasFlexRowReverseParent;
